import { useState } from 'react'
import { Button, Modal, Textarea } from '@/components/ui'

export interface RejectReviewModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  customer: string
  pending: boolean
  error: string | null
  onConfirm: (reason: string) => void
}

/** Sends the review back with a reason the author can act on. */
export function RejectReviewModal({ open, onOpenChange, customer, pending, error, onConfirm }: RejectReviewModalProps) {
  const [reason, setReason] = useState('')
  return (
    <Modal
      surface="form"
      open={open}
      onOpenChange={onOpenChange}
      tone="danger"
      title={`Reject the price review for ${customer}?`}
      description="It goes back to the author with your reason. Nothing changes in Odoo."
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={() => onOpenChange(false)} disabled={pending}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" onClick={() => onConfirm(reason.trim())} disabled={!reason.trim() || pending}>
            {pending ? 'Rejecting…' : 'Reject review'}
          </Button>
        </>
      }
    >
      <label className="flex flex-col gap-1">
        <span className="text-role-section-label">Reason</span>
        <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="What needs to change?" />
      </label>
      {error ? <p className="mt-2 text-xs text-danger">{error}</p> : null}
    </Modal>
  )
}
